if (!customElements.get('dd-video-library')) {
  customElements.define('dd-video-library', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.addEventListener('play', (event) => {
        if (!(event.target instanceof HTMLVideoElement)) return;
        this.querySelectorAll('video').forEach((video) => {
          if (video !== event.target) video.pause();
        });
      }, { capture: true, signal });
      const track = this.querySelector('[id^="Slider-"]');
      const controls = this.querySelector('.dd-stories__controls');
      this.resizeObserver?.disconnect();
      if (track && controls) {
        const updateControls = () => {
          controls.hidden = track.scrollWidth <= track.clientWidth + 2;
        };
        this.resizeObserver = new ResizeObserver(updateControls);
        this.resizeObserver.observe(track);
        updateControls();
      }
      track?.addEventListener('keydown', (event) => {
        if (event.target !== track) return;
        if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          track.scrollTo({ left: event.key === 'Home' ? 0 : track.scrollWidth });
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.querySelector(event.key === 'ArrowLeft' ? '[name="previous"]' : '[name="next"]')?.click();
        }
      }, { signal });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.querySelectorAll('video').forEach((video) => video.pause());
      }, { signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.querySelectorAll('video').forEach((video) => video.pause());
    }
  });
}
